import { MDText } from 'i18n-react';

import texts from './AccountSettingsCompanyInformation.texts';
import type { Associate, KycSection } from './AccountSettingsCompanyInformation.types';
import { COMPANY_INFORMATION_STEP } from './AccountSettingsCompanyInformation.types';

const localText = new MDText(texts);

export const MOBILE_PHONE_PREFIX = '+44';

export const KYC_SECTIONS: KycSection[] = [
	{
		id: COMPANY_INFORMATION_STEP.COMPANY_DETAILS,
		percentageCompleted: 0,
		text: `${localText.translate('actions.companyDetails')}`,
	},
	{
		id: COMPANY_INFORMATION_STEP.DIRECTORS,
		percentageCompleted: 0,
		text: `${localText.translate('actions.directors')}`,
	},
	{
		id: COMPANY_INFORMATION_STEP.BENEFICIAL_OWNERS,
		percentageCompleted: 0,
		text: `${localText.translate('actions.beneficialOwners')}`,
	},
	{
		id: COMPANY_INFORMATION_STEP.AUTHORISED_USERS,
		percentageCompleted: 0,
		text: `${localText.translate('actions.authorisedUsers')}`,
	},
	{
		id: COMPANY_INFORMATION_STEP.SUMMARY,
		percentageCompleted: 0,
		text: `${localText.translate('actions.summary')}`,
	},
];

export const DRAFT_ASSOCIATE: Partial<Associate> = {
	dateOfBirth: '',
	emailAddress: '',
	fullName: '',
	isDraft: true,
	isPrimaryContact: false,
};

export const EMPTY_STATE_ASSOCIATE: Partial<Associate> = {
	isDraft: true,
	isPrimaryContact: true,
};

export const VALIDATION_ERROR = {
	DATE_INVALID: 'dateInvalid',
	EMAIL_INVALID: 'emailInvalid',
	PHONE_NUMBER_INVALID: 'phoneNumberInvalid',
} as const;
